module.exports = __webpack_public_path__ + "img/product-smoke-55.56f5ae0c.jpg";